<template>
  <div>
    <b-button id="mf_modalSecurity_btn" v-b-modal="'mf_register_securityModal'"><span>+</span></b-button>
    <b-modal ok-only size="xl" hide-header ok-title="Fermer" id="mf_register_securityModal" centered>
      <div class="mf_register_securityModal_title">
        La sécurité et la confidentialité de vos informations
      </div>
      <div class="mf_register_securityModal_content">
        Nous savons que vous êtes particulièrement attentifs à l'utilisation de vos données personnelles ; nous vous remercions de la confiance que vous nous accordez pour les traiter en toute sécurité et à bon escient. Nous avons conçu nos systèmes en conformité avec les réglementations applicables, et notamment le Règlement Général de l'UE sur la Protection des Données.
      </div>
      <div class="mf_register_securityModal_title">
        Connexion à votre espace client
      </div>
      <div class="mf_register_securityModal_content">
        Lors de votre connexion à votre espace client, nous vous demandons de saisir votre identifiant et votre mot de passe. Conservez votre mot de passe pour vous, sans jamais le communiquer à un tiers. Jamais, nous ne vous contacterons pour vous demander votre mot de passe. Nous ne connaissons pas votre mot de passe, et nous ne vous enverrons jamais un email avec votre mot de passe. Si un tiers vous demande votre mot de passe, ignorez la demande et contactez-nous immédiatement à l’adresse :
        contact@myfo.fr Nous vous recommandons de vous déconnecter après chaque utilisation.
      </div>
      <div class="mf_register_securityModal_title">
        Connexions aux plateformes de gestion de portefeuille
      </div>
      <div class="mf_register_securityModal_content">
        Pour vous connecter à vos plateformes de gestion de portefeuille, nous vous demandons les identifiants et les mots de passe associés. Nous ne conservons pas ces données de connexion ; c’est pourquoi nous vous les demandons à chaque fois que nécessaire. Nous n’utilisons pas de cookie pour mémoriser ces informations. Une bonne pratique est de ne pas réutiliser le même mot de passe sur plusieurs plateformes. Afin de pallier aux éventuels oublis, nous avons mis en place un système de “time
        out”, qui vous déconnecte au bout d’un certain temps d’inactivité. Nous collectons la composition de votre portefeuille, et sa valorisation. Nous protégeons la sécurité de ces informations personnelles lors de leur transmission en utilisant des protocoles de cryptage. Nous maintenons des mesures de sécurité physiques, électroniques et des procédures de sauvegarde adaptées pour la conservation de vos données. Si vous souhaitez ajuster la composition de votre portefeuille, vous pouvez vous
        assurer que seuls les mouvements que vous avez personnellement validés ont été opérés, en consultant le journal d'opérations et les positions de votre portefeuille avant / après, que nous mettons à votre disposition.
      </div>
      <div class="mf_register_securityModal_title">
        Quels sont vos droits concernant ces données personnelles ?
      </div>
      <div class="mf_register_securityModal_content">
        Conformément aux articles 16 à 19 du “Règlement Général sur la Protection des Données” (RGPD) mis en vigueur le 25 mai 2018, vous bénéficiez d’un droit de rectification et d’effacement de l’ensemble des informations personnelles qui vous concernent. L’article 20 du RGPD communément appelé “droit à la portabilité”, vous confère le droit de récupérer vos informations personnelles si vous souhaitez les transférer à un autre organisme. Pour exercer ces droits, vous pouvez à tout moment
        envoyer un e-mail à l’adresse suivante : contact@myfo.fr. Si vous avez des questions concernant la protection et la sécurité de vos données personnelles, vous pouvez nous contacter à l’adresse : contact@myfo.fr. Responsable des traitements du site myfo.fr : société Myfo, Membre n° E009383 de l’ANACOFI-CIF, association agréée par l’AMF - Numéro Orias 20002629 SAS au capital de 3 000 € - RCS 881 061 840
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
@import "../../../../../sass/_variables.scss";
#mf_modalSecurity_btn {
  $size: 40px;
  border-radius: 50px;
  padding: 0px;
  height: $size;
  width: $size;
  background: black;
  border: none;

  &:hover {
    background: $bg_color_bl;
  }

  span {
    position: relative;
    font-weight: bold;
    font-size: 30px !important;
    color: $mf_ft_color_white !important;
    top: -3px;
    right: 0px;
  }
}

#mf_register_securityModal {
  $margin: 40px;

  #mf_register_securityModal___BV_modal_content_ {
    background: #121212 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 20px;
    opacity: 1;
    padding: 20px;
  }

  #mf_register_securityModal___BV_modal_footer_ {
    border: none;

    button {
      background: $blue_color 0% 0% no-repeat padding-box;
      box-shadow: 0px 3px 6px #00000029;
      border-radius: 41px;
      opacity: 1;
      border: none;
      width: 35%;
    }
  }

  .mf_register_securityModal_title {
    text-align: left;
    font: normal normal normal 30px/40px Segoe UI;
    letter-spacing: 0px;
    color: #ffffff;
    opacity: 1;
    margin-top: $margin;
  }

  .mf_register_securityModal_content {
    margin-top: $margin;
    text-align: left;
    font: normal normal normal 20px/27px Segoe UI;
    letter-spacing: 0px;
    color: #707070;
    opacity: 1;
  }
}
</style>
